import { Star } from "lucide-react";

interface SaladItem {
  id: number;
  name: string;
  description: string;
  price: number | string;
  image: string;
  rating: number;
  ingredients: string[];
}

const saladItems: SaladItem[] = [
  {
    id: 1,
    name: "Pro-Paneer Bowl",
    description: "A Virant fusion of grilled paneer, black channa, and fresh veggies - protien meets radiance in every bite!!",
    price: '149/-',
    image: "/paneerprobowl.jpg",
    rating: 4.8,
    ingredients: ["Grilled Paneer", "Black Channa", "Cucumbers", "Fresh herbs", "Lemon vinaigrette"]
  },
  {
    id: 2,
    name: "Vegan Muscle Bowl",
    description: "Spiced tofu, crunchy veggies, and zero junk.",
    price: '149/-',
    image: "/vegganmuscle.jpg",
    rating: 4.3,
    ingredients: ["Tofu", "Tomates", "Beetroot", "Tomatoes", "Oregano dressing"]
  },
  {
    id: 3,
    name: "FiberFit Channa Bowl",
    description: "Carrots, tomato, purple cabbage, green capsicum, and row mango",
    price: '149/-',
    image: "/fiberfitchannabowl.jpg",
    rating: 4.1,
    ingredients: ["Black Chana", "Carrots", "Chickpeas", "Cucumber", "Natural dressing"]
  },
  {
    id: 4,
    name: "Corn Craze Bowl",
    description: "Boiled Sweet Corn, Chopped Onion and Tomato, Diced Cucumber, shreded carrots",
    price: '149/-',
    image: "/corncraze.jpg",
    rating: 4.9,
    ingredients: ["Seasonal vegetables", "Sprouts", "Mixed seeds", "Balsamic glaze", "Baby greens"]
  }
];

export default function FreshSaladMenu() {
  return (
    <section id="menu" className="py-24 bg-amber-50 relative overflow-hidden" style={{backgroundColor: 'rgba(255, 251, 235, 0.95)'}}>
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-200/20 to-indigo-200/10 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-purple-200/20 to-blue-200/10 rounded-full blur-3xl translate-x-48 translate-y-48"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
            Fresh Salad Menu
          </h2>
          <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            Each salad is carefully crafted with the freshest seasonal ingredients,
            locally sourced and prepared with love for maximum flavor and nutrition.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 xl:grid-cols-4 md:grid-cols-2 gap-8">
          {saladItems.map((item, index) => (
            <div key={item.id} className="group relative">
              {/* Beautiful Card */}
              <div className="relative bg-white rounded-3xl p-1 hover:shadow-2xl hover:shadow-blue-500/20 transition-all duration-500 hover:scale-105 border border-blue-100 hover:border-blue-200">
                <div className="bg-white rounded-3xl overflow-hidden relative h-full">
                  {/* Image Section */}
                  <div className="relative overflow-hidden rounded-t-3xl">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    {/* Light Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>

                    {/* Rating Badge */}
                    <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm text-amber-600 px-3 py-1.5 rounded-xl text-sm font-semibold flex items-center gap-1 shadow-lg border border-amber-200">
                      <Star className="h-3 w-3 fill-current" />
                      {item.rating}
                    </div>

                    {/* Price Badge */}
                    <div className="absolute bottom-4 left-4 bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-4 py-2 rounded-xl text-lg font-bold shadow-lg">
                    ₹{item.price}
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                      {item.name}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {item.description}
                    </p>

                    {/* Ingredients Tags */}
                    <div className="flex flex-wrap gap-2 mb-6">
                      {item.ingredients.slice(0, 3).map((ingredient) => (
                        <span key={ingredient} className="px-3 py-1.5 text-xs bg-blue-100 text-blue-700 rounded-full font-medium border border-blue-200">
                          {ingredient}
                        </span>
                      ))}
                      {item.ingredients.length > 3 && (
                        <span className="px-3 py-1.5 text-xs bg-gray-100 text-gray-600 rounded-full font-medium">
                          +{item.ingredients.length - 3} more
                        </span>
                      )}
                    </div>

                    {/* Add to Cart Button */}
                    <button className="w-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 hover:from-blue-600 hover:via-indigo-600 hover:to-purple-600 text-white font-semibold py-4 px-6 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-blue-500/25 text-lg">
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
